import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatPaginatorModule } from '@angular/material/paginator';
import { AppSelectableRowDirective } from './selectable-row.directive';
import { AppSortIconComponent } from './sort-icon.component';
import { AppSortableColumnDirective } from './sortable-column.directive';
import { AppTableComponent } from './table.component';
import { AppTableTemplateDirective } from './table-templates.directive';

@NgModule({
    imports: [CommonModule, MatPaginatorModule],
    declarations: [
        AppTableComponent,
        AppTableTemplateDirective,
        AppSortableColumnDirective,
        AppSortIconComponent,
        AppSelectableRowDirective,
    ],
    exports: [
        AppTableComponent,
        AppTableTemplateDirective,
        AppSortableColumnDirective,
        AppSortIconComponent,
        AppSelectableRowDirective,
    ],
})
export class UiTableModule {}

